import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { MEDIA } from "@/lib/media";

const PROGRAMS = [
  { to: "/service-dog-program", label: "Service Dog Program" },
  { to: "/trainer-program", label: "Master Trainer Program" },
  { to: "/veterans", label: "For Veterans" },
  { to: "/artists", label: "Artist Gallery" },
];
const ABOUT = [
  { to: "/golden-founder", label: "Golden Founder" },
  { to: "/about", label: "About Golden Wolf" },
  { to: "/mission", label: "Our Mission" },
  { to: "/financial-transparency", label: "Financial Transparency" },
  { to: "/contact", label: "Contact" },
];
const WAYS = [
  { to: "/donate", label: "Donate Money" },
  { to: "/wishlist", label: "In-Kind Wish List" },
  { to: "/drop-off", label: "Donation Drop-Off" },
  { to: "/volunteer", label: "Volunteer" },
  { to: "/sponsors", label: "Corporate Sponsors" },
];

function Dropdown({ label, items, testid }) {
  return (
    <div className="relative group" data-testid={testid}>
      <button className="flex items-center gap-1 text-sm text-[#C8C4B7] hover:text-[#D4AF37] transition-colors py-2">
        {label} <ChevronDown className="w-4 h-4" />
      </button>
      <div className="absolute left-0 top-full pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-200 z-50">
        <div className="bg-[#141414] border border-white/10 min-w-[240px] py-2 shadow-2xl">
          {items.map((it) => (
            <Link key={it.to} to={it.to} data-testid={`nav-${it.to.slice(1)}`}
              className="block px-5 py-2.5 text-sm text-[#C8C4B7] hover:text-[#D4AF37] hover:bg-white/5 transition-colors">
              {it.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const allMobile = [...WAYS, ...PROGRAMS, { to: "/14ddv", label: "14DDV Event" }, ...ABOUT];

  return (
    <header className="sticky top-0 z-50 bg-[#0A0A0A]/80 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16 sm:h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-home-logo" onClick={() => setOpen(false)}>
          <img src={MEDIA.logo} alt="Golden Wolf Foundation logo" className="h-12 w-12 object-contain" />
          <div className="hidden sm:block leading-tight">
            <div className="font-heading text-[#FDFBF7] text-lg font-bold">Golden Wolf</div>
            <div className="text-[10px] tracking-[0.25em] text-[#D4AF37]">FOUNDATION</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          <Dropdown label="Give" items={WAYS} testid="nav-give" />
          <Dropdown label="Programs" items={PROGRAMS} testid="nav-programs" />
          <NavLink to="/14ddv" data-testid="nav-14ddv" className={({isActive}) => `text-sm transition-colors ${isActive ? "text-[#D4AF37]" : "text-[#C8C4B7] hover:text-[#D4AF37]"}`}>14DDV Event</NavLink>
          <Dropdown label="About" items={ABOUT} testid="nav-about" />
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/donate" className="hidden sm:inline-block btn-gold text-sm" data-testid="nav-donate-btn">Donate Now</Link>
          <button className="lg:hidden text-[#FDFBF7]" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0A0A0A] border-t border-white/10 max-h-[80vh] overflow-y-auto" data-testid="mobile-menu">
          {allMobile.map((it) => (
            <Link key={it.to} to={it.to} onClick={() => setOpen(false)}
              className="block px-6 py-3.5 text-sm text-[#C8C4B7] hover:text-[#D4AF37] border-b border-white/5">
              {it.label}
            </Link>
          ))}
          <div className="p-4"><Link to="/donate" onClick={() => setOpen(false)} className="btn-gold block text-center">Donate Now</Link></div>
        </div>
      )}
    </header>
  );
}
